const config = {
  WIDTH: 500,
  ROWS: 25,
  REFRESH_RATE: 100,
  ANIM_WAIT_TIME: 100,
};
export default config;
